import { Container } from '@cleartrip/ct-design-components'
import React from 'react'
import EmiOptionsHeader from './EmiOptionsHeader'
import EmiBankOption from './EmiBankOption'
import EmiOptionsLoader from '@/components/itinerary/Aside/EmiBlock/EmiOptions/EmiOptionsList/EmiOptionsLoader'
import EmiOptionsError from '@/components/itinerary/Aside/EmiBlock/EmiOptions/EmiOptionsList/EmiOptionsError'

interface EmiOptionsListProps {
    emiOptionsData: any
    processingFeeMsg: string
    onClose: () => void
    isLoading: boolean
    isError: boolean
    handleRetry?: () => void
}

const EmiOptionsList: React.FC<EmiOptionsListProps> = ({ emiOptionsData = [], processingFeeMsg = '', onClose, isLoading, isError, handleRetry }) => {
    return (
        <Container className="bg-white flex flex-column" style={{ width: '440px', height: '100vh' }}>
            <EmiOptionsHeader onClose={onClose} />
            {isLoading ? (
                <EmiOptionsLoader />
            ) : isError ? (
                <EmiOptionsError handleRetry={handleRetry}/>
            ) : (
                <EmiBankOption emiOptionsData={emiOptionsData} processingFeeMsg={processingFeeMsg} />
            )}
        </Container>
    )
}

export default EmiOptionsList
